module.exports = __webpack_public_path__ + "static/img/h-logo.38e1229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/h-logo.png
// module id = Kwv0
// module chunks = 29